import React, { useEffect, useState } from 'react';
import axiosInstance from 'apis/axiosConfig';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const UpdateNews = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    news_title: '',
    description: '',
    category: '',
    state: '',
    language: '',
    youtube_url: '',
    thumbnail: null,
    existingImage: '',
    is_active: 1
  });
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_BACKEND_URL}/category`)
      .then((res) => {
        const list = Array.isArray(res?.data) ? res.data : [];
        setCategories(list.filter((cat) => cat && cat.name).map((cat) => cat.name));
      })
      .catch((err) => console.error('Error fetching categories:', err));
  }, []);

  // Keep the current value visible even if it is a legacy category name not in the DB list
  const selectOptions =
    formData.category && !categories.includes(formData.category)
      ? [formData.category, ...categories]
      : categories;

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_BACKEND_URL}/product/one/${id}`)
      .then((res) => {
        const news = res.data;

        setFormData({
          news_title: news.news_title || '',
          description: news.description || '',
          category: news.category || '',
          state: news.state || '',
          language: news.language || '',
          youtube_url: news.youtube_url || '',
          thumbnail: null,
          existingImage: news.thumbnail ? `${process.env.REACT_APP_BACKEND}uploads/news/${news.thumbnail}` : '',
          is_active: news.is_active ?? 1
        });
      })
      .catch((err) => {
        console.error('Error fetching news:', err);
      });
  }, [id]);

  // Keep the current value visible even if it is a legacy language name not in the list
  const languageOptions = [
    { value: 'hindi', label: 'Hindi' },
    { value: 'english', label: 'English' }
  ];
  const selectedLanguage = languageOptions.find((l) => l.value === formData.language);

  const handleChange = (e) => {
    const { name, type, value, files, checked } = e.target;

    if (type === 'file') {
      setFormData({ ...formData, thumbnail: files[0] });
    } else if (type === 'checkbox') {
      setFormData({ ...formData, [name]: checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedData = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (key === 'thumbnail') {
        if (value) updatedData.append('thumbnail', value);
      } else if (!key.startsWith('existing')) {
        updatedData.append(key, value);
      }
    });

axiosInstance
      .patch(`${process.env.REACT_APP_BACKEND_URL}/product/${id}`, updatedData)
      .then(() => {
        toast.success('News updated successfully!');
        navigate('/ournews');
      })
      .catch((err) => {
        console.error('Update failed:', err);
        toast.error('Failed to update news');
      });
  };

  return (
    <div className="container-fluid mt-4 mt-md-5 ournews-page">
      <div className="mainheadig mx-2 mx-md-4">
        <h4 className="text-white font-weight-bold">Update News</h4>
      </div>

      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row mx-2 mx-md-4">
          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="news_title">
              Title
            </label>
            <input
              id="news_title"
              name="news_title"
              value={formData.news_title}
              onChange={handleChange}
              className="form-control"
              required
            />
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="category">
              Category
            </label>
            <select id="category" name="category" value={formData.category} onChange={handleChange} className="form-control" required>
              <option value="">Select Category</option>
              {selectOptions.map((cat, i) => (
                <option key={i} value={cat}>
                  {cat}
                </option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="state">
              State
            </label>
            <select id="state" name="state" value={formData.state} onChange={handleChange} className="form-control" required>
              <option value="">Select State</option>
              {[
                'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
                'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
              ].map((s, i) => (
                <option key={i} value={s}>{s}</option>
              ))}
            </select>
          </div>

          <div className="col-12 col-md-6 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="language">
              Language
            </label>
            <select id="language" name="language" value={formData.language} onChange={handleChange} className="form-control" required>
              <option value="">Select Language</option>
              {languageOptions.map((lang) => (
                <option key={lang.value} value={lang.value}>
                  {lang.label}
                </option>
              ))}
              {formData.language && !selectedLanguage ? (
                <option value={formData.language}>{formData.language}</option>
              ) : null}
            </select>
          </div>

          <div className="col-12 mt-3 mt-md-4">
            <label className="adminlables" htmlFor="youtube_url">
              YouTube URL
            </label>
            <input id="youtube_url" name="youtube_url" value={formData.youtube_url} onChange={handleChange} className="form-control" />
          </div>

          <div className="col-12 mt-3 mt-md-4">
            <label htmlFor="description" className="adminlables">
              Description
            </label>
            <textarea id="description" name="description" value={formData.description} onChange={handleChange} className="form-control" rows={4} />
          </div>

          <div className="col-12 mt-3 mt-md-4">
            <label htmlFor="thumbnail" className="adminlables">
              Upload Thumbnail
            </label>
            <input id="thumbnail" type="file" name="thumbnail" className="form-control filebg" accept="image/*" onChange={handleChange} />
          </div>
        </div>

        {formData.thumbnail ? (
          <div className="mx-2 mx-md-4 mt-3">
            <img src={URL.createObjectURL(formData.thumbnail)} alt="preview" width={150} className="img-fluid rounded ournews-preview-img" />
          </div>
        ) : formData.existingImage ? (
          <div className="mx-2 mx-md-4 mt-3">
            <img src={formData.existingImage} alt="existing" width={150} className="img-fluid rounded ournews-preview-img" />
          </div>
        ) : null}

        <div className="mx-2 mx-md-4 mt-3 form-check">
          <input id="is_active" type="checkbox" name="is_active" checked={formData.is_active === 1} onChange={handleChange} />
          <label htmlFor="is_active" className="ml-2 mb-0">
            Active
          </label>
        </div>

        <div className="mt-4 mt-md-5 text-center text-md-right mx-2 mx-md-4">
          <button type="submit" className="btn btn-lg addbtn">
            Update News
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateNews;
